import loadable from "@loadable/component";
import { isValid } from "date-fns";
import { inject } from "mobx-react";

import { getDateFormat, getLang } from "@ihr-radioedit/inferno-core";
import { DATETIME_DISPLAY_FORMATS } from "@inferno/renderer-shared-core";
import "./DateSeparator.style.scss";
import type { Store } from "@inferno/renderer-shared-core";

const DateDisplay = loadable(() => import("../../components/DateDisplay.component"));

interface DateSeparatorProps {
  timestamp: number;
  timezone?: string;
  store?: Store;
}

export const DateSeparator = inject("store")(({ timestamp, store }: DateSeparatorProps) => {
  if (timestamp > 0 && isValid(timestamp) && store?.env) {
    let dateFormat = DATETIME_DISPLAY_FORMATS.SHORT_MONTH_DAY_FULL_YEAR;
    let timezone = store.env.DEFAULT_TIMEZONE;
    let language = "en";
    if (store?.site) {
      dateFormat = getDateFormat(store.site, "separator");
      timezone = store.site.index.timeZone || timezone;
      language = getLang(store.site);
    }

    return (
      <DateDisplay
        datetime={timestamp}
        dateFormat={dateFormat}
        timezone={timezone}
        className="component-date-separator"
        language={language}
      />
    );
  }
  return null;
});
